module.exports = __webpack_public_path__ + "img/develop.74358d6e.svg";